import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Link } from '../../primitives/Link/index.js';
export const ActionLink = /*#__PURE__*/_styled(forwardRef(function ActionLink(props, ref) {
  return _jsx(Link, {
    ref: ref,
    as: "button",
    type: "button",
    ...props
  });
}), process.env.NODE_ENV === "production" ? {
  target: "etjgf5e0"
} : {
  target: "etjgf5e0",
  label: "ActionLink"
})(process.env.NODE_ENV === "production" ? {
  name: "1nmhg9b",
  styles: "padding:0;border:0;background:none;cursor:pointer;&:hover,&:active{text-decoration:none;}"
} : {
  name: "1nmhg9b",
  styles: "padding:0;border:0;background:none;cursor:pointer;&:hover,&:active{text-decoration:none;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkFjdGlvbkxpbmsuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTUkiLCJmaWxlIjoiQWN0aW9uTGluay5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBmb3J3YXJkUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgTGluayB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvTGluay9pbmRleC5qcyc7XG5leHBvcnQgY29uc3QgQWN0aW9uTGluayA9IHN0eWxlZChmb3J3YXJkUmVmKGZ1bmN0aW9uIEFjdGlvbkxpbmsocHJvcHMsIHJlZikge1xuICAgIHJldHVybiBfanN4KExpbmssIHsgcmVmOiByZWYsIGFzOiBcImJ1dHRvblwiLCB0eXBlOiBcImJ1dHRvblwiLCAuLi5wcm9wcyB9KTtcbn0pKSBgXG4gIHBhZGRpbmc6IDA7XG4gIGJvcmRlcjogMDtcbiAgYmFja2dyb3VuZDogbm9uZTtcbiAgY3Vyc29yOiBwb2ludGVyO1xuXG4gICY6aG92ZXIsXG4gICY6YWN0aXZlIHtcbiAgICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG4gIH1cbmA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1BY3Rpb25MaW5rLmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});